import { render, staticRenderFns } from "./DraftList.vue?vue&type=template&id=4474b632&scoped=true"
import script from "./DraftList.vue?vue&type=script&lang=js"
export * from "./DraftList.vue?vue&type=script&lang=js"
import style0 from "./DraftList.vue?vue&type=style&index=0&id=4474b632&prod&lang=scss&scoped=true"
import style1 from "./DraftList.vue?vue&type=style&index=1&id=4474b632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4474b632",
  null
  
)

export default component.exports